import { DEFAULT_API_BASE_URL } from './constants';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

export const baseUrl = {
  analyticService:
    process.env.REACT_APP_ANALYTIC_SERVICE_BASE_URL || `${apiBaseUrl}/analytics-service`,
  cmsService: process.env.REACT_APP_CMS_SERVICE_BASE_URL || `${apiBaseUrl}/cms-service`,
  merchantService:
    process.env.REACT_APP_MERCHANT_SERVICE_BASE_URL || `${apiBaseUrl}/merchant-service`,
  contactService: process.env.REACT_APP_CONTACT_SERVICE_BASE_URL || `${apiBaseUrl}/contact-service`,
  orderService: process.env.REACT_APP_ORDER_SERVICE_BASE_URL || `${apiBaseUrl}/order-service`,
  organizationService:
    process.env.REACT_APP_ORGANIZATION_SERVICE_BASE_URL || `${apiBaseUrl}/organization-service`,
  productService: process.env.REACT_APP_PRODUCT_SERVICE_BASE_URL || `${apiBaseUrl}/product-service`
};
